// /* eslint-disable */
// import React, { useEffect, useRef, useState } from 'react';
// import { useHistory } from "react-router-dom";
// import { FaThLarge, FaChevronDown, FaChevronUp } from 'react-icons/fa';
// import { FaUserShield } from 'react-icons/fa';
// import PropTypes from 'prop-types';
// import styles from './Sidebar.module.css';
// import { DeliveryLogoIcon, OrderLogoIcon, HireLogoIcon, ProcureLogoIcon, RecordLogoIcon, ImportLogisticsIcon } from '../../assets/icons/gdcIcons/delivery';
// import { KnowledgeLogoIcon, ControlLogoIcon, DirectTaxLogoIcon, IdtLogoIcon, LegalLogoIcon } from '../../assets/icons/gdcIcons/Knowledge';
// import { EnablingLogoIcon, FinanceLogoIcon, ProcessLogoIcon, QualityLogoIcon, TalentLogoIcon, TransitionLogoIcon,HSNIcon } from '../../assets/icons/gdcIcons/Enabling';
// import FileUploadIcon from '../../assets/icons/gdcIcons/FileUploadIcon';
// import FileApproverIcon from '../../assets/icons/gdcIcons/FileApproverIcon';
// import { useRoleAccess } from '../HomePageComp/roleAccess';

// import { useDispatch } from "react-redux";
// import { setPageName,clearPageName } from "../../redux/features/PageName/PageName";

// const Sidebar = ({ isRotate, notRotate, isOpen, isClose, onPageChange }) => {

//   const sidebarRef = useRef(null);
//   const history = useHistory();
    
//   const dispatch = useDispatch();

//   const { hasCategory, hasSubCategory } = useRoleAccess();
//   const [openSubmenus, setOpenSubmenus] = useState({});
//   const [selectedMenu, setSelectedMenu] = useState('');
//   const [selectedSubmenu, setSelectedSubmenu] = useState('');
//   const [hasAdminAccess, setHasAdminAccess] = useState(false);
  
//   useEffect(() => {
//     console.log("test role data -------------->", sessionStorage.getItem("userRole"));
//     const roleString = sessionStorage.getItem("userRole") || "";
//     const roleList = roleString.split(","); 
//     // console.log("test role data -------------->", roleList);
//     if (roleList.includes("AdminPageAccess")) {
//       setHasAdminAccess(true);
//     } else {
//       setHasAdminAccess(false);
//     }
//   }, []);

//   const toggleSubmenu = (label) => {
//     setOpenSubmenus((prev) => ({
//       // ...prev,
//       [label]: !prev[label],
//     }));
//   };

//   const menuData = [
//     {
//       label: 'Home',
//       icon: <FaThLarge size={24} />,
//       submenu: null,
//       path: '/',
//     },
//     ...(hasAdminAccess
//       ? [{
//           label: 'Admin',
//           icon: <FaUserShield size={24} />,
//           submenu: null,
//           path: '/Command-Center/Admin',
//         }]
//       : []),
//     {
//       label: 'Delivery',
//       icon: <DeliveryLogoIcon size={24} />,
//       submenu: [
//         { label: 'R2R', icon: <RecordLogoIcon size={24} />, path: '/Record-To-Report' },
//         // { label: 'H2R', icon: <HireLogoIcon size={24} />, path: '/Hire-To-Retire' },
//         { label: 'H2R', icon: <HireLogoIcon size={24} />, path: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=8b17069c-8752-499e-bd1c-565836b83695&ctid=a3fb180d-23c4-44c9-a241-c78109202bd3&experience=power-bi' },
//         { label: 'O2C', icon: <OrderLogoIcon size={24} />, path: '/Order-To-Cash' },
//         { label: 'P2P', icon: <ProcureLogoIcon size={24} />, path: '/Procure-To-Pay' },
//         { label: 'Vendor GL Ageing', icon: <ProcureLogoIcon size={24} />, path: '/GL-Reconciliation' },
//         { label: 'Import Logistics', icon: <ImportLogisticsIcon size={24} />, path: 'https://pfirstv2.tmindia.tatamotors.com/' },
//         { label: 'MSME Genie', icon: <ImportLogisticsIcon size={24} />, path: 'https://msme-2106525843804885.aws.databricksapps.com/' },
//       ],
//     },
//     {
//       label: 'Knowledge',
//       icon: <KnowledgeLogoIcon size={24} />,
//       submenu: [
//         { label: 'Indirect Tax', icon: <IdtLogoIcon size={24} />, path: '/Indirect-Tax' },
//         { label: 'Legal', icon: <LegalLogoIcon size={24} />, path: '/Legal-Page' },
//         { label: 'Direct Tax', icon: <DirectTaxLogoIcon size={24} />, path: '/Direct-Tax' },
//         { label: 'Control & Complaince', icon: <ControlLogoIcon size={24} />, path: '/Control-Complaince' },
//       ],
//     },
//     {
//       label: 'Enabling',
//       icon: <EnablingLogoIcon size={24} />,
//       submenu: [
//         { label: 'Transition', icon: <TransitionLogoIcon size={24} />, path: '/Transition-Page' },
//         // { label: 'Process & Excellence Quality', icon: <ProcessLogoIcon size={24} />, path: '/Process-Excellence-Quality' },
//         { label: 'Transformation', icon: <ProcessLogoIcon size={24} />, path: '/Process-Excellence' },
//         { label: 'Quality', icon: <QualityLogoIcon size={24} />, path: '/Quality' },
//         // { label: 'Talent', icon: <TalentLogoIcon size={24} />, path: '/Talent-Page' },
//         { label: 'Talent', icon: <TalentLogoIcon size={24} />, path: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=8b17069c-8752-499e-bd1c-565836b83695&ctid=a3fb180d-23c4-44c9-a241-c78109202bd3&experience=power-bi' },
//         { label: 'Finance', icon: <FinanceLogoIcon size={24} />, path: '/Finance-Page' },
//       ],
//     },
//     {
//       label: 'File Upload',
//       icon: <FileUploadIcon size={24} />,
//       submenu: [
//         { label: 'Process Upload User', icon: <FileUploadIcon size={24} />, path: '/File-Upload-Page' },
//         { label: 'Process Upload Approver', icon: <FileApproverIcon size={34} />, path: '/File-Upload-Check-Page' },
//         { label: 'Template Upload Approver', icon: <FileApproverIcon size={34} />, path: '/Template-Upload-Approve-Page' }
//       ],
//     },
//         {
//       label: 'HSN Report',
//       icon: <HSNIcon />,
//       submenu: [
//         { label: 'HSN Exception Report', icon: <TransitionLogoIcon size={24} />, path: '/HSN-Report-1' },
//          { label: 'HSN GST Rate wise Report', icon: <TransitionLogoIcon size={24} />, path: '/HSN-Report-2' },
//         // { label: 'Process Upload Approver', icon: <FileApproverIcon size={34} />, path: '/File-Upload-Check-Page' },
//         // { label: 'Template Upload Approver', icon: <FileApproverIcon size={34} />, path: '/Template-Upload-Approve-Page' }
//       ],
//     },
//   ];

//   // const handleSubmenuClick = (menuLabel, submenuItem) => {
//   //   console.log("test click -------->", submenuItem);
    
//   //   // if (submenuItem.path) history.push(submenuItem.path);
//   //   // setSelectedMenu(menuLabel);
//   //   // setSelectedSubmenu(submenuItem.label);
//   //   // if (onPageChange) onPageChange(`${submenuItem.label} Dashboard`);
//   //   // isClose(false);
//   //   // notRotate(!isRotate);
//   //   if (submenuItem.label === 'Talent' || submenuItem.label === 'H2R') {
//   //     window.open(submenuItem.path, '_blank');
//   //   } else {
//   //     if (submenuItem.path) history.push(submenuItem.path);
//   //     setSelectedMenu(menuLabel);
//   //     setSelectedSubmenu(submenuItem.label);
//   //     if (onPageChange) onPageChange(`${submenuItem.label} Dashboard`);
//   //   }
//   //   dispatch(setPageName(`${submenuItem.label} Dashboard`));
//   //   isClose(false);
//   //   notRotate(!isRotate);
//   // };

//   const handleSubmenuClick = (menuLabel, submenuItem) => {
//     if (submenuItem.label === 'Talent' || submenuItem.label === 'H2R' || submenuItem.label === 'Import Logistics' || submenuItem.label === 'MSME Genie') {
//       window.open(submenuItem.path, '_blank');
//     } else {
//       if (submenuItem.path) history.push(submenuItem.path);
//       setSelectedMenu(menuLabel);
//       setSelectedSubmenu(submenuItem.label);
//       if (onPageChange) onPageChange(`${submenuItem.label} Dashboard`);
//     }
//   };

//   // const handleSubmenuClick = (menuLabel, submenuItem) => {
//   //   if (submenuItem.path) history.push(submenuItem.path);
//   //   setSelectedMenu(menuLabel);
//   //   setSelectedSubmenu(submenuItem.label);
//   //   if (onPageChange) onPageChange(`${submenuItem.label} Dashboard`);
//   // };

//   return (
//     <div ref={sidebarRef} className={`${styles.sidebar} ${isOpen ? styles.open : styles.closed}`}>
//       <div className={styles.menu}>
//         {/* {menuData.map((item, index) => (
//           <div key={index}>
//             <div
//                 className={`${styles.menuItem} ${selectedMenu === item.label && !selectedSubmenu ? styles.selectedBox : ''}`}
//                 onClick={() => {
//                   if (item.submenu) {
//                     toggleSubmenu(item.label);
//                     setSelectedMenu(item.label);
//                     setSelectedSubmenu('');
//                   } else if (item.path) {
//                     history.push(item.path);
//                     setSelectedMenu(item.label);
//                     setSelectedSubmenu('');
//                     if (onPageChange) onPageChange(item.label); 
//                   }
//                 }}
//             >
//               {item.icon}
//               {isOpen && (
//                 <>
//                   <span>{item.label}</span>
//                   {item.submenu && (
//                     <span className={styles.chevron}>
//                       {openSubmenus[item.label] ? <FaChevronUp /> : <FaChevronDown />}
//                     </span>
//                   )}
//                 </>
//               )}
//             </div>

//             {isOpen && item.submenu && openSubmenus[item.label] && (
//               <div className={styles.submenu}>
//                 {item.submenu.map((sub, subIndex) => (
//                   <div
//                     key={subIndex}
//                     className={`${styles.submenuItem} ${
//                     selectedSubmenu === sub.label ? styles.selectedBox : ''
//                     }`}
//                     onClick={() => handleSubmenuClick(item.label, sub)}
//                   >
//                     {sub.icon && <span className={styles.submenuIcon}>{sub.icon}</span>}
//                     <span>{sub.label}</span>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         ))} */}

//         {menuData.map((item, index) => {
//           // If item has submenu, show only if any of its subitems are accessible
//           if (item.submenu) {
//             const visibleSubmenu = item.submenu.filter(sub => hasSubCategory(sub.label));
//             if (visibleSubmenu.length === 0) return null;

//             return (
//               <div key={index}>
//                 <div
//                   className={`${styles.menuItem} ${selectedMenu === item.label && !selectedSubmenu ? styles.selectedBox : ''}`}
//                   // onClick={() => {
//                   //   toggleSubmenu(item.label);
//                   //   setSelectedMenu(item.label);
//                   //   setSelectedSubmenu('');
//                   // }}
//                   onClick={() => {
//                     isClose(true)
//                     if (item.submenu) {
//                       toggleSubmenu(item.label);
//                       setSelectedMenu(item.label);
//                       setSelectedSubmenu('');
//                     } else if (item.path) {
//                       history.push(item.path);
//                       setSelectedMenu(item.label);
//                       setSelectedSubmenu('');
//                       if (onPageChange) onPageChange(item.label);
//                     }
//                   }}
//                 >
//                   {item.icon}
//                   {isOpen && (
//                     <>
//                       <span>{item.label}</span>
//                       <span className={styles.chevron}>
//                         {openSubmenus[item.label] ? <FaChevronUp /> : <FaChevronDown />}
//                       </span>
//                     </>
//                   )}
//                 </div>

//                 {isOpen && openSubmenus[item.label] && (
//                   <div className={styles.submenu}>
//                     {visibleSubmenu.map((sub, subIndex) => (
//                       <div
//                         key={subIndex}
//                         className={`${styles.submenuItem} ${selectedSubmenu === sub.label ? styles.selectedBox : ''}`}
//                         onClick={() => handleSubmenuClick(item.label, sub)}
//                       >
//                         {sub.icon && <span className={styles.submenuIcon}>{sub.icon}</span>}
//                         <span>{sub.label}</span>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             );
//           } else {
//             // For tiles without submenus (like "Home"), show only if user has category access
//             // if (!hasCategory(item.label)) return null;

//             return (
//               <div key={index}>
//                 <div
//                   className={`${styles.menuItem} ${selectedMenu === item.label ? styles.selectedBox : ''}`}
//                   onClick={() => {
//                     history.push(item.path);
//                     setSelectedMenu(item.label);
//                     setSelectedSubmenu('');
//                     dispatch(setPageName('Home'));
//                     if (onPageChange) onPageChange(item.label);
//                   }}
//                 >
//                   {item.icon}
//                   {isOpen && <span>{item.label}</span>}
//                 </div>
//               </div>
//             );
//           }
//         })}

//       </div>
//     </div>
//   );
// };

// Sidebar.propTypes = {
//   isOpen: PropTypes.bool,
//   onPageChange: PropTypes.func,
// };

// export default Sidebar;



// ######################## new code nestedSubmenu ###########################

/* eslint-disable */
// import React, { useEffect, useRef, useState } from 'react';
// import { useHistory } from "react-router-dom";
// import { FaThLarge, FaChevronDown, FaChevronUp } from 'react-icons/fa';
// import { FaUserShield } from 'react-icons/fa';
// import PropTypes from 'prop-types';
// import styles from './Sidebar.module.css';
// import { DeliveryLogoIcon, OrderLogoIcon, HireLogoIcon, ProcureLogoIcon, RecordLogoIcon, ImportLogisticsIcon } from '../../assets/icons/gdcIcons/delivery';
// import { KnowledgeLogoIcon, ControlLogoIcon, DirectTaxLogoIcon, IdtLogoIcon, LegalLogoIcon } from '../../assets/icons/gdcIcons/Knowledge';
// import { EnablingLogoIcon, FinanceLogoIcon, ProcessLogoIcon, QualityLogoIcon, TalentLogoIcon, TransitionLogoIcon, HSNIcon } from '../../assets/icons/gdcIcons/Enabling';
// import FileUploadIcon from '../../assets/icons/gdcIcons/FileUploadIcon';
// import FileApproverIcon from '../../assets/icons/gdcIcons/FileApproverIcon';
// import { useRoleAccess } from '../HomePageComp/roleAccess';
// import { useDispatch } from "react-redux";
// import { setPageName, clearPageName } from "../../redux/features/PageName/PageName";
// import {
//   FaTools,
//   FaDatabase,
//   FaMoneyCheckAlt,
//   FaCogs,
//   FaHeadset,
//   FaHandshake
// } from "react-icons/fa";


// const Sidebar = ({ isRotate, notRotate, isOpen, isClose, onPageChange }) => {

//   const sidebarRef = useRef(null);
//   const history = useHistory();
//   const dispatch = useDispatch();

//   const { hasCategory, hasSubCategory } = useRoleAccess();
//   const [openSubmenus, setOpenSubmenus] = useState({});
//   const [selectedMenu, setSelectedMenu] = useState('');
//   const [selectedSubmenu, setSelectedSubmenu] = useState('');
//   const [hasAdminAccess, setHasAdminAccess] = useState(false);

//   useEffect(() => {
//     // console.log("test role data -------------->", sessionStorage.getItem("userRole"));
//     const roleString = sessionStorage.getItem("userRole") || "";
//     const roleList = roleString.split(",");
//     if (roleList.includes("AdminPageAccess")) {
//       setHasAdminAccess(true);
//     } else {
//       setHasAdminAccess(false);
//     }
//   }, []);

//   const toggleSubmenu = (label) => {
//     setOpenSubmenus((prev) => ({
//       // ...prev,
//       [label]: !prev[label],
//     }));
//   };

//   const menuData = [
//     {
//       label: 'Home',
//       icon: <FaThLarge size={24} />,
//       submenu: null,
//       path: '/',
//     },
//     ...(hasAdminAccess
//       ? [{
//         label: 'Admin',
//         icon: <FaUserShield size={24} />,
//         submenu: null,
//         path: '/Command-Center/Admin',
//       }]
//       : []),
//     {
//       label: 'Delivery',
//       icon: <DeliveryLogoIcon size={24} />,
//       submenu: [
//         // { label: 'R2R', icon: <RecordLogoIcon size={24} />, path: '/Record-To-Report' },
//         {
//           label: 'R2R',
//           icon: <RecordLogoIcon size={24} />,
//           path: '/Record-To-Report',
//           submenu: [
//             { label: 'GL Coverage & Reconciliation', path: 'https://app.powerbi.com/groups/me/apps/ce11ea5b-3b01-4d8e-a722-1d3e247763c6/reports/31a8dcf9-f6a7-45e4-93f4-8f6ebbdecf56?ctid=a3fb180d-23c4-44c9-a241-c78109202bd3&experience=power-bi' },
//           ]
//         },
//         // { label: 'H2R', icon: <HireLogoIcon size={24} />, path: '/Hire-To-Retire' },
//         { label: 'H2R', icon: <HireLogoIcon size={24} />, path: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=8b17069c-8752-499e-bd1c-565836b83695&ctid=a3fb180d-23c4-44c9-a241-c78109202bd3&experience=power-bi' },
//         { label: 'O2C', icon: <OrderLogoIcon size={24} />, path: '/Order-To-Cash' },
//         // { label: 'P2P', icon: <ProcureLogoIcon size={24} />, path: '/Procure-To-Pay' },
//         // {
//         //   label: 'P2P',
//         //   icon: <ProcureLogoIcon size={24} />,
//         //   path: '/Procure-To-Pay',
//         //   submenu: [
//         //     { label: 'Purchase', icon: <FaTools size={18}/>, path: '/Procure-To-Pay/Purchase' },
//         //     { label: 'MDM', icon: <FaDatabase size={18}/>, path: '/Procure-To-Pay/MDM' },
//         //     { label: 'CRDO', icon: <FaCogs size={18}/>, path: '/Procure-To-Pay/CRDO' },
//         //     { 
//         //       label: 'Account Payables',  
//         //       icon: <FaMoneyCheckAlt size={18}/>, 
//         //       path: '/Procure-To-Pay/Account-Payable', 
//         //       submenu: [
//         //         { label: 'A/C Payable Vendor GL Ageing', path: '/Procure-To-Pay/Account-Payable/GL-Reconciliation' },
//         //               ]
//         //     },
//         //     { label: 'Vendor Payment Scheme', icon: <FaHandshake size={18}/>, path: '/Procure-To-Pay/Vendor-Payment-Scheme' },
//         //     { label: 'VMO & Contact Center', icon: <FaHeadset size={18}/>, path: '/Procure-To-Pay/VMO-Contact-center' },
//         //   ]
//         // },
//         {
//           label: 'P2P',
//           icon: <ProcureLogoIcon size={24} />,
//           path: '/Procure-To-Pay',
//           submenu: [
//             { label: 'Purchase', icon: <FaTools size={18} />, path: '/Procure-To-Pay/Purchase' },
        
//             { label: 'MDM', icon: <FaDatabase size={18} />, path: '/Procure-To-Pay/MDM' },
        
//             { label: 'CRDO', icon: <FaCogs size={18} />, path: '/Procure-To-Pay/CRDO' },
        
//             {
//               label: 'Account Payables',
//               icon: <FaMoneyCheckAlt size={18} />,
//               path: '/Procure-To-Pay/Account-Payable',
//               submenu: [
//                 {
//                   label: 'Vendor GL Ageing',
//                   // icon: <ProcureLogoIcon size={16} />,
//                   path: '/Procure-To-Pay/Account-Payable/GL-Reconciliation'
//                 }
//               ]
//             },
        
//             {
//               label: 'Vendor Payment Scheme',
//               icon: <FaHandshake size={18} />,
//               path: '/Procure-To-Pay/Vendor-Payment-Scheme'
//             },
        
//             {
//               label: 'VMO & Contact Center',
//               icon: <FaHeadset size={18} />,
//               path: '/Procure-To-Pay/VMO-Contact-center'
//             }
//           ]
//         },
//         // { label: 'Vendor GL Ageing', icon: <ProcureLogoIcon size={24} />, path: '/GL-Reconciliation' },
//         { label: 'Import Logistics', icon: <ImportLogisticsIcon size={24} />, path: 'https://pfirstv2.tmindia.tatamotors.com/' },
//         { label: 'MSME Genie', icon: <ImportLogisticsIcon size={24} />, path: 'https://msme-2106525843804885.aws.databricksapps.com/' },
//       ],
//     },
//     {
//       label: 'Knowledge',
//       icon: <KnowledgeLogoIcon size={24} />,
//       submenu: [
//         { label: 'Indirect Tax', icon: <IdtLogoIcon size={24} />, path: '/Indirect-Tax' },
//         { label: 'Legal', icon: <LegalLogoIcon size={24} />, path: '/Legal-Page' },
//         { label: 'Direct Tax', icon: <DirectTaxLogoIcon size={24} />, path: '/Direct-Tax' },
//         { label: 'Control & Complaince', icon: <ControlLogoIcon size={24} />, path: '/Control-Complaince' },
//       ],
//     },
//     {
//       label: 'Enabling',
//       icon: <EnablingLogoIcon size={24} />,
//       submenu: [
//         { label: 'Transition', icon: <TransitionLogoIcon size={24} />, path: '/Transition-Page' },
//         // { label: 'Process & Excellence Quality', icon: <ProcessLogoIcon size={24} />, path: '/Process-Excellence-Quality' },
//         { label: 'Transformation', icon: <ProcessLogoIcon size={24} />, path: '/Process-Excellence' },
//         { label: 'Quality', icon: <QualityLogoIcon size={24} />, path: '/Quality' },
//         // { label: 'Talent', icon: <TalentLogoIcon size={24} />, path: '/Talent-Page' },
//         { label: 'Talent', icon: <TalentLogoIcon size={24} />, path: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=8b17069c-8752-499e-bd1c-565836b83695&ctid=a3fb180d-23c4-44c9-a241-c78109202bd3&experience=power-bi' },
//         { label: 'Finance', icon: <FinanceLogoIcon size={24} />, path: '/Finance-Page' },
//       ],
//     },
//     {
//       label: 'File Upload',
//       icon: <FileUploadIcon size={24} />,
//       submenu: [
//         { label: 'Process Upload User', icon: <FileUploadIcon size={24} />, path: '/File-Upload-Page' },
//         { label: 'Process Upload Approver', icon: <FileApproverIcon size={34} />, path: '/File-Upload-Check-Page' },
//         { label: 'Template Upload Approver', icon: <FileApproverIcon size={34} />, path: '/Template-Upload-Approve-Page' }
//       ],
//     },
//     {
//       label: 'HSN Report',
//       icon: <HSNIcon />,
//       submenu: [
//         { label: 'HSN Exception Report', icon: <TransitionLogoIcon size={24} />, path: '/HSN-Report-1' },
//         { label: 'HSN GST Rate wise Report', icon: <TransitionLogoIcon size={24} />, path: '/HSN-Report-2' },
//       ],
//     },
//   ];

//   const handleSubmenuClick = (menuLabel, submenuItem) => {
//     // console.log("test data ----------->", submenuItem.label);
//     if (submenuItem.label === 'Talent' || submenuItem.label === 'H2R' || submenuItem.label === 'Import Logistics' || submenuItem.label === 'MSME Genie') {
//       window.open(submenuItem.path, '_blank');
//     } else {
//       if (submenuItem.path) history.push(submenuItem.path);
//       setSelectedMenu(menuLabel);
//       setSelectedSubmenu(submenuItem.label);
//       if (onPageChange) onPageChange(`${submenuItem.label} Dashboard`);
//       dispatch(setPageName(`${submenuItem.label} Dashboard`));
//       isClose(false);
//       notRotate(!isRotate);
//     }
//   };

//   const handlenestedSubmenuClick = (nestedPath, itemLabel,nestedLabel, subLabel) => {
//     if (nestedLabel === 'GL Coverage & Reconciliation' ) {
//       window.open(nestedPath, '_blank');
//     } else {
//       history.push(nestedPath);
//       setSelectedMenu(itemLabel);
//       setSelectedSubmenu(nestedLabel);
//       dispatch(setPageName(`${subLabel} - ${nestedLabel} Dashboard`));
//       // isClose(false);
//       notRotate(!isRotate);
//       // dispatch(setPageName(`${sub.label} Dashboard`));
//     }
//   }

//   return (
//     <div ref={sidebarRef} className={`${styles.sidebar} ${isOpen ? styles.open : styles.closed}`}>
//       <div className={styles.menu}>
//         {menuData.map((item, index) => {
//           if (item.submenu) {
//             const visibleSubmenu = item.submenu.filter(sub => hasSubCategory(sub.label));
//             if (visibleSubmenu.length === 0) return null;

//             return (
//               <div key={index}>
//                 <div
//                   className={`${styles.menuItem} ${selectedMenu === item.label && !selectedSubmenu ? styles.selectedBox : ''}`}
//                   onClick={() => {
//                     isClose(true)
//                     if (item.submenu) {
//                       toggleSubmenu(item.label);
//                       setSelectedMenu(item.label);
//                       setSelectedSubmenu('');
//                     } else if (item.path) {
//                       history.push(item.path);
//                       setSelectedMenu(item.label);
//                       setSelectedSubmenu('');
//                       if (onPageChange) onPageChange(item.label);
//                     }
//                   }}
//                 >
//                   {item.icon}
//                   {isOpen && (
//                     <>
//                       <span>{item.label}</span>
//                       <span className={styles.chevron}>
//                         {openSubmenus[item.label] ? <FaChevronUp /> : <FaChevronDown />}
//                       </span>
//                     </>
//                   )}
//                 </div>

//                 {isOpen && openSubmenus[item.label] && (
//                   <div className={styles.submenu}>
//                     {visibleSubmenu.map((sub, subIndex) => {
//                       if (sub.submenu) {
//                         return (
//                           <div key={subIndex}>
//                             <div
//                               className={`${styles.submenuItem} ${selectedSubmenu === sub.label ? styles.selectedBox : ''}`}
//                               onClick={() => {
//                                 isClose(true)
//                                 if (sub.path) history.push(sub.path);
//                                 setOpenSubmenus(prev => ({
//                                   ...prev,
//                                   [sub.label]: !prev[sub.label]
//                                 }));
//                                 setSelectedMenu(item.label);
//                                 setSelectedSubmenu(sub.label);
//                                 dispatch(setPageName(`${sub.label} Dashboard`));
//                               }}
//                             >
//                               {sub.icon && <span className={styles.submenuIcon}>{sub.icon}</span>}
//                               <span>{sub.label}</span>
//                               <span className={styles.chevron}>
//                                 {openSubmenus[sub.label] ? <FaChevronUp /> : <FaChevronDown />}
//                               </span>
//                             </div>
//                             {/* Nested submenu */}
//                             {openSubmenus[sub.label] && (
//                               <div className={styles.nestedSubmenu}>
//                                 {/* {sub.submenu.map((nested, nestedIndex) => (
//                                   <div
//                                     key={nestedIndex}
//                                     className={`${styles.submenuItem} ${selectedSubmenu === nested.label ? styles.selectedBox : ''}`}
//                                     onClick={() => handlenestedSubmenuClick(nested.path, item.label ,nested.label, sub.label)}
//                                   >
//                                     <span>{nested.icon}</span>
//                                     {nested.icon && <span className={styles.submenuIcon}>{nested.icon}</span>}
//                                     <span>{nested.label}</span>
                                    
//                                   </div>
//                                 ))
//                                 } */}
//                                 {sub.submenu.map((nested, nestedIndex) => {
//                                     if (nested.submenu) {
//                                       return (
//                                         <div key={nestedIndex}>
//                                           <div
//                                             className={`${styles.submenuItem} ${selectedSubmenu === nested.label ? styles.selectedBox : ''}`}
//                                             onClick={() => {
//                                               isClose(true)
//                                               handlenestedSubmenuClick(nested.path, item.label ,nested.label, sub.label)
//                                               setOpenSubmenus(prev => ({
//                                                 ...prev,
//                                                 [nested.label]: !prev[nested.label]
//                                               }));
//                                             }}
//                                           >
//                                             {nested.icon && <span className={styles.submenuIcon}>{nested.icon}</span>}
//                                             <span>{nested.label}</span>
//                                             <span className={styles.chevron}>
//                                               {openSubmenus[nested.label] ? <FaChevronUp /> : <FaChevronDown />}
//                                             </span>
//                                           </div>
//                                           {/* Level 3 submenu */}
//                                           {openSubmenus[nested.label] && (
//                                             <div className={styles.levelThreeSubmenu}>
//                                               {nested.submenu.map((level3, i) => (
//                                                 <div
//                                                   key={i}
//                                                   className={styles.submenuItem}
//                                                   onClick={() => {history.push(level3.path);
//                                                     setSelectedMenu(i.label);
//                                                     setSelectedSubmenu(level3.label);
                                              
//                                                     dispatch(setPageName(`${sub.label} - ${level3.label} Dashboard`));
                                              
//                                                     if (onPageChange) {
//                                                       onPageChange(`${level3.label} Dashboard`);
//                                                     }
                                              
//                                                     isClose(false);
//                                                     notRotate(!isRotate);}}
//                                                 >
//                                                   {/* {level3.icon && (
//                                                     <span className={styles.submenuIcon}>{level3.icon}</span>
//                                                   )} */}
//                                                   <span>{level3.label}</span>
//                                                 </div>
//                                               ))}
//                                             </div>
//                                           )}
//                                         </div>
//                                       );
//                                     }

//                                     // return (
//                                     //   <div
//                                     //     key={nestedIndex}
//                                     //     className={styles.submenuItem}
//                                     //     onClick={() => history.push(nested.path)}
//                                     //   >
//                                     //     {nested.icon && <span className={styles.submenuIcon}>{nested.icon}</span>}
//                                     //     <span>{nested.label}</span>
//                                     //   </div>
//                                     // );
//                                     return (
//                                       <div
//                                         key={nestedIndex}
//                                         className={styles.submenuItem}
//                                         onClick={() => {
//                                           history.push(nested.path);
//                                           setSelectedMenu(item.label);
//                                           setSelectedSubmenu(nested.label);
                                    
//                                           dispatch(setPageName(`${sub.label} - ${nested.label} Dashboard`));
                                    
//                                           if (onPageChange) {
//                                             onPageChange(`${nested.label} Dashboard`);
//                                           }
                                    
//                                           isClose(false);
//                                           notRotate(!isRotate);
//                                         }}
//                                       >
//                                         {nested.icon && <span className={styles.submenuIcon}>{nested.icon}</span>}
//                                         <span>{nested.label}</span>
//                                       </div>
//                                     );
//                                     })}
//                               </div>
//                             )}
//                           </div>
//                         );
//                       }
//                       return (
//                         <div
//                           key={subIndex}
//                           className={`${styles.submenuItem} ${selectedSubmenu === sub.label ? styles.selectedBox : ''}`}
//                           onClick={() => handleSubmenuClick(item.label, sub)}
//                         >
//                           {sub.icon && <span className={styles.submenuIcon}>{sub.icon}</span>}
//                           <span>{sub.label}</span>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 )}
//               </div>
//             );
//           } else {
//             return (
//               <div key={index}>
//                 <div
//                   className={`${styles.menuItem} ${selectedMenu === item.label ? styles.selectedBox : ''}`}
//                   onClick={() => {
//                     history.push(item.path);
//                     setSelectedMenu(item.label);
//                     setSelectedSubmenu('');
//                     dispatch(setPageName('Home'));
//                     if (onPageChange) onPageChange(item.label);
//                   }}
//                 >
//                   {item.icon}
//                   {isOpen && <span>{item.label}</span>}
//                 </div>
//               </div>
//             );
//           }
//         })}

//       </div>
//     </div>
//   );
// };

// Sidebar.propTypes = {
//   isOpen: PropTypes.bool,
//   onPageChange: PropTypes.func,
// };

// export default Sidebar;



// ########################## New Code By shubham 13-03-26 ################################

/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from "react-router-dom";
import { FaThLarge, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { FaUserShield } from 'react-icons/fa';
import PropTypes from 'prop-types';
import styles from './Sidebar.module.css';
import { DeliveryLogoIcon, OrderLogoIcon, HireLogoIcon, ProcureLogoIcon, RecordLogoIcon, ImportLogisticsIcon } from '../../assets/icons/gdcIcons/delivery';
import { KnowledgeLogoIcon, ControlLogoIcon, DirectTaxLogoIcon, IdtLogoIcon, LegalLogoIcon } from '../../assets/icons/gdcIcons/Knowledge';
import { EnablingLogoIcon, FinanceLogoIcon, ProcessLogoIcon, QualityLogoIcon, TalentLogoIcon, TransitionLogoIcon, HSNIcon } from '../../assets/icons/gdcIcons/Enabling';
import FileUploadIcon from '../../assets/icons/gdcIcons/FileUploadIcon';
import FileApproverIcon from '../../assets/icons/gdcIcons/FileApproverIcon';
import { useRoleAccess } from '../HomePageComp/roleAccess';
import { useDispatch } from "react-redux";
import { setPageName, clearPageName } from "../../redux/features/PageName/PageName";
import {
  FaTools,
  FaDatabase,
  FaMoneyCheckAlt,
  FaCogs,
  FaHeadset,
  FaHandshake
} from "react-icons/fa";


const Sidebar = ({ isRotate, notRotate, isOpen, isClose, onPageChange }) => {
  const sidebarRef = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();

  // const { hasCategory, hasSubCategory } = useRoleAccess();
  // const { hasPage, hasPageAccess } = useRoleAccess();

  const roleAccess = useRoleAccess();
  const { hasCategory, hasSubCategory, hasPage, hasPageAccess } = roleAccess;

  const [openSubmenus, setOpenSubmenus] = useState({});
  const [selectedMenu, setSelectedMenu] = useState('');
  const [selectedSubmenu, setSelectedSubmenu] = useState('');
  const [hasAdminAccess, setHasAdminAccess] = useState(false);

  useEffect(() => {
    // console.log("test role data -------------->", sessionStorage.getItem("userRole"));
    const roleString = sessionStorage.getItem("userRole") || "";
    const roleList = roleString.split(",");
    if (roleList.includes("AdminPageAccess")) {
      setHasAdminAccess(true);
    } else {
      setHasAdminAccess(false);
    }
  }, []);

  const toggleSubmenu = (label) => {
    setOpenSubmenus((prev) => ({
      // ...prev,
      [label]: !prev[label],
    }));
  };

  const menuData = [
    {
      label: 'Home',
      icon: <FaThLarge size={24} />,
      submenu: null,
      path: '/',
    },
    ...(hasAdminAccess
      ? [{
        label: 'Admin',
        icon: <FaUserShield size={24} />,
        submenu: null,
        path: '/Command-Center/Admin',
      }]
      : []),
    {
      label: 'Delivery',
      icon: <DeliveryLogoIcon size={24} />,
      submenu: [
        // { label: 'R2R', icon: <RecordLogoIcon size={24} />, path: '/Record-To-Report' },
        {
          label: 'R2R',
          icon: <RecordLogoIcon size={24} />,
          path: '/Record-To-Report',
          submenu: [
            { 
              label: 'GL Coverage & Reconciliation',
              path: 'https://app.powerbi.com/groups/me/apps/ce11ea5b-3b01-4d8e-a722-1d3e247763c6/reports/31a8dcf9-f6a7-45e4-93f4-8f6ebbdecf56?ctid=a3fb180d-23c4-44c9-a241-c78109202bd3&experience=power-bi'
            },
          ]
        },
        // { label: 'H2R', icon: <HireLogoIcon size={24} />, path: '/Hire-To-Retire' },
        { label: 'H2R', icon: <HireLogoIcon size={24} />, path: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=8b17069c-8752-499e-bd1c-565836b83695&ctid=a3fb180d-23c4-44c9-a241-c78109202bd3&experience=power-bi' },
        { label: 'O2C', icon: <OrderLogoIcon size={24} />, path: '/Order-To-Cash' },
        {
          label: 'P2P',
          icon: <ProcureLogoIcon size={24} />,
          path: '/Procure-To-Pay',
          submenu: [
            { label: 'Purchase', icon: <FaTools size={18} />, path: '/Procure-To-Pay/Purchase' },
        
            { label: 'MDM', icon: <FaDatabase size={18} />, path: '/Procure-To-Pay/MDM' },
        
            { label: 'CRDO', icon: <FaCogs size={18} />, path: '/Procure-To-Pay/CRDO' },
        
            {
              label: 'Account Payable',
              icon: <FaMoneyCheckAlt size={18} />,
              path: '/Procure-To-Pay/Account-Payable',
              submenu: [
                {
                  label: 'Vendor GL Ageing',
                  path: '/Procure-To-Pay/Account-Payable/GL-Reconciliation'
                },
                {
                  label: 'Retention GL',
                  path: '/Procure-To-Pay/Account-Payable/Retention-GL-Reconciliation'
                },
              ]
            },
        
            {
              label: 'Vendor Payment Scheme',
              icon: <FaHandshake size={18} />,
              path: '/Procure-To-Pay/Vendor-Payment-Scheme'
            },
        
            {
              label: 'VMO & Contact Center',
              icon: <FaHeadset size={18} />,
              path: '/Procure-To-Pay/VMO-Contact-center'
            }
          ]
        },
        // { label: 'Vendor GL Ageing', icon: <ProcureLogoIcon size={24} />, path: '/GL-Reconciliation' },
        { label: 'Import Logistics', icon: <ImportLogisticsIcon size={24} />, path: 'https://pfirstv2.tmindia.tatamotors.com/' },
        { label: 'MSME Genie', icon: <ImportLogisticsIcon size={24} />, path: 'https://msme-2106525843804885.aws.databricksapps.com/' },
      ],
    },
    {
      label: 'Knowledge',
      icon: <KnowledgeLogoIcon size={24} />,
      submenu: [
        { label: 'Indirect Tax', icon: <IdtLogoIcon size={24} />, path: '/Indirect-Tax' },
        { label: 'Legal', icon: <LegalLogoIcon size={24} />, path: '/Legal-Page' },
        { label: 'Direct Tax', icon: <DirectTaxLogoIcon size={24} />, path: '/Direct-Tax' },
        { label: 'Control & Complaince', icon: <ControlLogoIcon size={24} />, path: '/Control-Complaince' },
      ],
    },
    {
      label: 'Enabling',
      icon: <EnablingLogoIcon size={24} />,
      submenu: [
        { label: 'Transition', icon: <TransitionLogoIcon size={24} />, path: '/Transition-Page' },
        // { label: 'Process & Excellence Quality', icon: <ProcessLogoIcon size={24} />, path: '/Process-Excellence-Quality' },
        { label: 'Transformation', icon: <ProcessLogoIcon size={24} />, path: '/Process-Excellence' },
        { label: 'Quality', icon: <QualityLogoIcon size={24} />, path: '/Quality' },
        // { label: 'Talent', icon: <TalentLogoIcon size={24} />, path: '/Talent-Page' },
        { label: 'Talent', icon: <TalentLogoIcon size={24} />, path: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=8b17069c-8752-499e-bd1c-565836b83695&ctid=a3fb180d-23c4-44c9-a241-c78109202bd3&experience=power-bi' },
        { label: 'Finance', icon: <FinanceLogoIcon size={24} />, path: '/Finance-Page' },
      ],
    },
    {
      label: 'File Upload',
      icon: <FileUploadIcon size={24} />,
      submenu: [
        { label: 'Process Upload User', icon: <FileUploadIcon size={24} />, path: '/File-Upload-Page' },
        { label: 'Process Upload Approver', icon: <FileApproverIcon size={34} />, path: '/File-Upload-Check-Page' },
        { label: 'Template Upload Approver', icon: <FileApproverIcon size={34} />, path: '/Template-Upload-Approve-Page' }
      ],
    },
    {
      label: 'HSN Report',
      icon: <HSNIcon />,
      submenu: [
        { label: 'HSN Exception Report', icon: <TransitionLogoIcon size={24} />, path: '/HSN-Report-1' },
        { label: 'HSN GST Rate wise Report', icon: <TransitionLogoIcon size={24} />, path: '/HSN-Report-2' },
      ],
    },
  ];

  const handleSubmenuClick = (menuLabel, submenuItem) => {
    if (submenuItem.label === 'Talent' || submenuItem.label === 'H2R' || submenuItem.label === 'Import Logistics' || submenuItem.label === 'MSME Genie') {
      window.open(submenuItem.path, '_blank');
    } else {
      if (submenuItem.path) history.push(submenuItem.path);
      setSelectedMenu(menuLabel);
      setSelectedSubmenu(submenuItem.label);
      if (onPageChange) onPageChange(`${submenuItem.label} Dashboard`);
      dispatch(setPageName(`${submenuItem.label} Dashboard`));
      isClose(false);
      notRotate(!isRotate);
    }
  };

  const handlenestedSubmenuClick = (nestedPath, itemLabel,nestedLabel, subLabel) => {
      history.push(nestedPath);
      setSelectedMenu(itemLabel);
      setSelectedSubmenu(nestedLabel);
      dispatch(setPageName(`${subLabel} - ${nestedLabel} Dashboard`));
      // isClose(false);
      notRotate(!isRotate);
      // dispatch(setPageName(`${sub.label} Dashboard`));
  }

  return (
    <div ref={sidebarRef} className={`${styles.sidebar} ${isOpen ? styles.open : styles.closed}`}>
      <div className={styles.menu}>
        {menuData.map((item, index) => {
          if (item.submenu) {
            const visibleSubmenu = item.submenu.filter(sub => hasSubCategory(sub.label));
            if (visibleSubmenu.length === 0) return null;
            return (
              <div key={index}>
                <div
                  className={`${styles.menuItem} ${selectedMenu === item.label && !selectedSubmenu ? styles.selectedBox : ''}`}
                  onClick={() => {
                    isClose(true)
                    if (item.submenu) {
                      toggleSubmenu(item.label);
                      setSelectedMenu(item.label);
                      setSelectedSubmenu('');
                    } else if (item.path) {
                      history.push(item.path);
                      setSelectedMenu(item.label);
                      setSelectedSubmenu('');
                      if (onPageChange) onPageChange(item.label);
                    }
                  }}
                >
                  {item.icon}
                  {isOpen && (
                    <>
                      <span>{item.label}</span>
                      <span className={styles.chevron}>
                        {openSubmenus[item.label] ? <FaChevronUp /> : <FaChevronDown />}
                      </span>
                    </>
                  )}
                </div>

                {isOpen && openSubmenus[item.label] && (
                  <div className={styles.submenu}>
                    {visibleSubmenu.map((sub, subIndex) => {
                      if (sub.submenu) {
                        const visiblePageAccess = sub.submenu.filter(item => hasPageAccess(item.label));
                        console.log("visiblePageAccess------------:",visiblePageAccess)
                          return (
                            <div key={subIndex}>
                              <div
                                className={`${styles.submenuItem} ${selectedSubmenu === sub.label ? styles.selectedBox : ''}`}
                                onClick={() => {
                                  isClose(true)
                                  if (sub.path) history.push(sub.path);
                                  setOpenSubmenus(prev => ({
                                    ...prev,
                                    [sub.label]: !prev[sub.label]
                                  }));
                                  setSelectedMenu(item.label);
                                  setSelectedSubmenu(sub.label);
                                  dispatch(setPageName(`${sub.label} Dashboard`));
                                }}
                              >
                                {sub.icon && <span className={styles.submenuIcon}>{sub.icon}</span>}
                                <span>{sub.label}</span>
                                { visiblePageAccess.length >= 1 ?
                                <span className={styles.chevron}>
                                  {openSubmenus[sub.label] ? <FaChevronUp /> : <FaChevronDown />}
                                </span>
                                :
                                  <span className={styles.chevron}>
                                  {/* {openSubmenus[sub.label] ? <FaChevronUp /> : <FaChevronDown />} */}
                                </span>
                                }
                              </div>
                              {/* Nested submenu */}
                              {isOpen && openSubmenus[sub.label] && (
                                <div className={styles.nestedSubmenu}>
                                  {visiblePageAccess.map((nested, nestedIndex) => {
                                    if (nested.submenu) {
                                        const visibleSubPageAccess = nested.submenu.filter(item => hasPageAccess(item.label));
                                        return (
                                          <div key={nestedIndex}>
                                            <div
                                              className={`${styles.submenuItem} ${selectedSubmenu === nested.label ? styles.selectedBox : ''}`}
                                              onClick={() => {
                                                isClose(true)
                                                handlenestedSubmenuClick(nested.path, item.label ,nested.label, sub.label)
                                                setOpenSubmenus(prev => ({
                                                  ...prev,
                                                  [nested.label]: !prev[nested.label]
                                                }));
                                              }}
                                            >
                                              {nested.icon && <span className={styles.submenuIcon}>{nested.icon}</span>}
                                              <span>{nested.label}</span>
                                              { visibleSubPageAccess.length >= 1 ?
                                              <span className={styles.chevron}>
                                                {openSubmenus[nested.label] ? <FaChevronUp /> : <FaChevronDown />}
                                              </span>
                                              :
                                              <span className={styles.chevron}>
                                                {/* {openSubmenus[nested.label] ? <FaChevronUp /> : <FaChevronDown />} */}
                                              </span>
                                              }
                                            </div>
                                            {/* Level 3 submenu */}
                                            {openSubmenus[nested.label] && (
                                              <div className={styles.levelThreeSubmenu}>
                                                {/* {nested.submenu.map((level3, i) => ( */}
                                                {visibleSubPageAccess.map((level3, i) => (
                                                  
                                                  <div
                                                    key={i}
                                                    className={styles.submenuItem}
                                                    onClick={() => {
                                                      history.push(level3.path);
                                                      setSelectedMenu(i.label);
                                                      setSelectedSubmenu(level3.label);
                                                      dispatch(setPageName(`${sub.label} - ${level3.label} Dashboard`));
                                                      if (onPageChange) {
                                                        onPageChange(`${level3.label} Dashboard`);
                                                      }
                                                      isClose(false);
                                                      notRotate(!isRotate);}}
                                                  >
                                                    {/* {level3.icon && (
                                                      <span className={styles.submenuIcon}>{level3.icon}</span>
                                                    )} */}
                                                    <span>{level3.label}</span>
                                                  </div>
                                                ))}
                                              </div>
                                            )}
                                          </div>
                                        );
                                      }
                                      return (
                                        <div
                                          key={nestedIndex}
                                          className={styles.submenuItem}
                                          onClick={() => {
                                            if (nested.label === 'GL Coverage & Reconciliation' ) {
                                              window.open(nested.path, '_blank');
                                            }else{
  
                                              history.push(nested.path);
                                              setSelectedMenu(item.label);
                                              setSelectedSubmenu(nested.label);
                                        
                                              dispatch(setPageName(`${sub.label} - ${nested.label} Dashboard`));
                                        
                                              if (onPageChange) {
                                                onPageChange(`${nested.label} Dashboard`);
                                              }
                                        
                                              isClose(false);
                                              notRotate(!isRotate);
                                            }
                                          }}
                                        >
                                          {nested.icon && <span className={styles.submenuIcon}>{nested.icon}</span>}
                                          <span>{nested.label}</span>
                                        </div>
                                      );
                                      })}
                                </div>
                              )}
                            </div>
                          );
                      }
                      return (
                        <div
                          key={subIndex}
                          className={`${styles.submenuItem} ${selectedSubmenu === sub.label ? styles.selectedBox : ''}`}
                          onClick={() => handleSubmenuClick(item.label, sub)}
                        >
                          {sub.icon && <span className={styles.submenuIcon}>{sub.icon}</span>}
                          <span>{sub.label}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          } else {
            return (
              <div key={index}>
                <div
                  className={`${styles.menuItem} ${selectedMenu === item.label ? styles.selectedBox : ''}`}
                  onClick={() => {
                    history.push(item.path);
                    setSelectedMenu(item.label);
                    setSelectedSubmenu('');
                    dispatch(setPageName('Home'));
                    if (onPageChange) onPageChange(item.label);
                  }}
                >
                  {item.icon}
                  {isOpen && <span>{item.label}</span>}
                </div>
              </div>
            );
          }
        })}

      </div>
    </div>
  );
};

Sidebar.propTypes = {
  isOpen: PropTypes.bool,
  onPageChange: PropTypes.func,
};

export default Sidebar;